import React from 'react';
import { motion } from 'framer-motion';

const VARIANT_STYLES = {
  default: {
    button: 'border-slate-200 bg-white hover:border-slate-300',
    title: 'text-slate-900 group-hover:text-red-600',
    description: 'text-slate-600',
  },
  danger: {
    button: 'border-red-200 bg-red-50 hover:border-red-300',
    title: 'text-red-800 group-hover:text-red-900',
    description: 'text-red-700',
  },
};

export default function DashboardButton({
  title,
  description, // kept for API compatibility, hidden from UI
  onClick,
  icon,
  color: _color = 'red',
  variant = 'default',
}) {
  const styles = VARIANT_STYLES[variant] || VARIANT_STYLES.default;

  return (
    <motion.button
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.4 }}
      onClick={onClick}
      className={`group text-left p-6 rounded-2xl border shadow-sm hover:shadow-lg transition-all duration-300 ${styles.button}`}
    >
      <div className="text-5xl mb-3 leading-none">{icon}</div>
      <h3 className={`text-sm font-semibold leading-tight transition-colors ${styles.title}`}>
        {title}
      </h3>
    </motion.button>
  );
}
